/**
 * @generated SignedSource<<326fe1d947c40b0ad53c633ace389fb9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EditMyProfileInput = {
  clientMutationId?: string | null | undefined;
  firstName?: string | null | undefined;
  lastName?: string | null | undefined;
};
export type EditMyProfileMutation$variables = {
  input: EditMyProfileInput;
};
export type EditMyProfileMutation$data = {
  readonly editMyProfile: {
    readonly errors: any | null | undefined;
    readonly profile: {
      readonly id: string;
      readonly user: {
        readonly firstName: string;
        readonly id: string;
        readonly lastName: string;
      };
    } | null | undefined;
    readonly success: boolean | null | undefined;
  } | null | undefined;
};
export type EditMyProfileMutation = {
  response: EditMyProfileMutation$data;
  variables: EditMyProfileMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EditMyProfilePayload",
    "kind": "LinkedField",
    "name": "editMyProfile",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProfileNode",
        "kind": "LinkedField",
        "name": "profile",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "DjangoUserNode",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditMyProfileMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditMyProfileMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "8e951afe064b009e04f78eaed59386b3",
    "id": null,
    "metadata": {},
    "name": "EditMyProfileMutation",
    "operationKind": "mutation",
    "text": "mutation EditMyProfileMutation(\n  $input: EditMyProfileInput!\n) {\n  editMyProfile(input: $input) {\n    success\n    errors\n    profile {\n      id\n      user {\n        id\n        firstName\n        lastName\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "541dafc689084aa9d3db889d1b457a37";

export default node;
